// src/index.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function AppShell({
  applicationName,
  applicationDescription,
  navigation = [],
  phaseLabel = "Phase 3",
  accountLabel,
  headerActions,
  footerText = "Template core foundation.",
  children
}) {
  return /* @__PURE__ */ jsxs("div", { className: "app-shell", children: [
    /* @__PURE__ */ jsx("a", { className: "skip-link", href: "#main-content", children: "Skip to main content" }),
    /* @__PURE__ */ jsxs("header", { className: "site-header", children: [
      /* @__PURE__ */ jsxs("div", { className: "site-header__inner", children: [
        /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("p", { className: "eyebrow", children: "Dispatch Platform v2" }),
          /* @__PURE__ */ jsx("h1", { children: applicationName }),
          /* @__PURE__ */ jsx("p", { className: "site-description", children: applicationDescription })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "header-meta", children: [
          /* @__PURE__ */ jsx("span", { className: "phase-badge", children: phaseLabel }),
          accountLabel ? /* @__PURE__ */ jsx("span", { className: "account-label", children: accountLabel }) : null,
          headerActions ? /* @__PURE__ */ jsx("div", { className: "header-actions", children: headerActions }) : null
        ] })
      ] }),
      navigation.length > 0 ? /* @__PURE__ */ jsx("nav", { "aria-label": `${applicationName} navigation`, children: /* @__PURE__ */ jsx("ul", { className: "nav-list", children: navigation.map((item) => /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(
        "a",
        {
          href: item.href,
          "aria-current": item.current ? "page" : void 0,
          onClick: (event) => {
            if (!item.onSelect) return;
            event.preventDefault();
            item.onSelect();
          },
          children: item.label
        }
      ) }, `${item.href}-${item.label}`)) }) }) : null
    ] }),
    /* @__PURE__ */ jsx("main", { id: "main-content", tabIndex: -1, children }),
    /* @__PURE__ */ jsx("footer", { children: /* @__PURE__ */ jsx("p", { children: footerText }) })
  ] });
}
function BuildInformation({ environment, version, application }) {
  return /* @__PURE__ */ jsxs("section", { className: "panel", "aria-labelledby": "build-information-heading", children: [
    /* @__PURE__ */ jsx("h2", { id: "build-information-heading", children: "Build information" }),
    /* @__PURE__ */ jsxs("dl", { className: "definition-grid", children: [
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("dt", { children: "Application" }),
        /* @__PURE__ */ jsx("dd", { children: application })
      ] }),
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("dt", { children: "Environment" }),
        /* @__PURE__ */ jsx("dd", { children: environment })
      ] }),
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("dt", { children: "Build version" }),
        /* @__PURE__ */ jsx("dd", { children: version })
      ] })
    ] })
  ] });
}
function StatusPanel({
  heading,
  children,
  tone = "success",
  id
}) {
  const headingId = `${id ?? "status"}-heading`;
  return /* @__PURE__ */ jsxs("section", { className: "panel", id, "aria-labelledby": headingId, children: [
    /* @__PURE__ */ jsx("h2", { id: headingId, children: heading }),
    /* @__PURE__ */ jsxs("div", { className: "status-row", children: [
      /* @__PURE__ */ jsx("span", { className: `status-indicator status-indicator--${tone}`, "aria-hidden": "true" }),
      /* @__PURE__ */ jsx("div", { className: "status-content", children })
    ] })
  ] });
}
function FoundationStatus({ children }) {
  return /* @__PURE__ */ jsx(StatusPanel, { heading: "Foundation status", id: "foundation", children: /* @__PURE__ */ jsx("p", { children }) });
}
function Alert({
  children,
  tone = "error",
  title
}) {
  return /* @__PURE__ */ jsxs("div", { className: `alert alert--${tone}`, role: tone === "error" ? "alert" : "status", children: [
    title ? /* @__PURE__ */ jsx("strong", { children: title }) : null,
    /* @__PURE__ */ jsx("div", { children })
  ] });
}
function LoadingPanel({ message = "Loading\u2026" }) {
  return /* @__PURE__ */ jsxs("section", { className: "panel loading-panel", "aria-live": "polite", "aria-busy": "true", children: [
    /* @__PURE__ */ jsx("span", { className: "spinner", "aria-hidden": "true" }),
    /* @__PURE__ */ jsx("p", { children: message })
  ] });
}
export {
  Alert,
  AppShell,
  BuildInformation,
  FoundationStatus,
  LoadingPanel,
  StatusPanel
};
